export const apiConstant = {
  profile: 'Profiles',
  committees: 'Admin/Committees',
  profileCommittee: 'Profiles/Committee',
  profilesThumbnails: 'Profiles/Thumbnails',
  auth: 'Auth',
  authLoginBoard: 'Auth/LoginBoard',
  authLoginChangePaasword: 'Auth/ChangePassword',
  authUserBoard: 'Auth/UserBoards',
  myProfile: 'Profiles/My',
  linksFloders: 'Links/Folders',
  links: 'Links',
  officerGroups: 'Admin/OfficerGroups',
  adminSettings: 'Admin/Settings/Docusign',
  security: 'Security',
  securityChangePassword: 'Security/ChangePassword',
  countries: 'Entities/Countries',
  timezones: 'TimeZones',
  login: 'Auth/Login',
  ssoDetails: 'Auth/SSO/SP/SsoData',
  verifyOTP: 'Auth/VerifyOtp',
  resendOTP: 'Auth/ResendOtp',
  forgotUsername: 'Auth/ValidateEmailLastName',
  ForgotPassword: 'Auth/ForgotPassword',
  adminUsersCommittee: 'Admin/Users/Committees',
  adminUsersRoles: 'Admin/Users/Roles',
  adminActiveUserReport: 'Admin/Reports/Users/Active',
  adminUserRolesAndCommitteesReport: 'Admin/Reports/Users/RolesAndCommittees',
  users: 'Entities/Users',
  adminUsersRole: 'Admin/Users/Roles',
  defaultCommittee: 'Profiles/DefaultCommittee',
  adminUsers: 'Admin/Users',
  roles: 'Entities/Roles',
  appointments: 'Entities/Appointments',
  companyName: 'Entities/CompanyName',
  securitySQA: 'Security/SQA',
  alertsTemplates: 'Alerts/Templates',
  newAlert: 'Alerts',
  alertsPublish: 'Publish',
  alertsUnPublish: 'UnPublish',
  alertsPublished: 'Alerts/Published',
  entitiesOfficerGroups: 'Entities/OfficerGroups',
  securityResetPassword: 'Security/ResetPassword',
  alertsUnpublished: 'Alerts/Unpublished',
  collaborations: 'Collaborations',
  collaborationsMeetings: 'Collaborations/Pickers/Committees',
  entitiesCommittees: 'Entities/Committees',
  meetingCommittees: 'Meetings/List/Picker/Committees',
  entitiesUsers: 'Entities/Users',
  entitiesCommitteesOfficerGroups: 'Entities/CommitteesOfficerGroups',
  documentsCache: 'Documents/Cache',
  meetings: 'Meetings',
  meetingsList: 'Meetings/List',
  plannerList: 'Meetings/Planner',
  alertsTemplate: 'Alerts/Template',
  alerts: 'Alerts',
  alertDocuments: 'Alerts/Documents',
  documents: 'Documents',
  meetingsAttendeesPickerCommittees: 'Meetings/Attendees/Picker/Committees',
  meetingDocPermissionDetails: 'documents-permission-info',
  meetingAttendanceReports: 'Meetings/AttendanceReport',
  exportMeetingAttendanceReport: 'Meetings/ExportAttendanceReport',
  attendance: 'Attendance',
  meetingExport: 'Meetings/Export',
  meetingsAttendees: 'Meetings/Attendees',
  alertsDocument: 'Alerts/Documents',
  addToCalendar: 'AddToCalendar',
  copy: 'Copy',
  unified: 'Unified',
  emailTemplate: 'Email/Template',
  emailSend: 'Email/Send',
  boardBook: 'BoardBook',
  evaluations: 'Evaluations',
  surveys: 'Surveys',
  recentUpdates: 'RecentUpdates',
  recentUpdatesHome: 'RecentUpdates/Home',
  references: 'References',
  test: 'Test',
  upcomingMeetings: 'Meetings/Dashboard/List',
  events: 'Meetings/Events',
  signatureRequests: 'SignatureRequests',
  workflow: 'Workflow',
  sendRemainder: 'SendReminder',
  signatureRequest: 'SignatureRequest',
  info: 'Info',
  discussions: 'Discussions',
  reply: 'Reply',
  archived: 'Archived',
  unArchived: 'UnArchived',
  intercom: 'Settings/Intercom',
  summary: 'Summary',
  settings: 'Settings',
  votings: 'Votings',
  AttendanceReports: 'AttendanceReport',
  search: 'Search',
  recipients: 'Recipients',
  alertsCommittees: 'Alerts/Committees',
  supportEmail: 'Profiles/SupportEmail',
  sga: 'SystemGeneratedAgendaItems',
  attendeesAppointment: 'AttendeesWithAppointment',
  annotations: 'Annotations',
  supportDesk: 'Profiles/SupportDesk',
  logout: 'Auth/Logout',
  sendReminder: 'SendReminder',
  downloadDocument: 'GenerateDownloadDocument',
  editDocusign: 'SignatureRequest/Edit',
  docuSign: 'DocuSign',
  consent: 'MS/Identity',
  sysCache: 'Sys/Cache',
  oneDrive: 'MS/OneDrive',
  systemFeature: 'Sys/FeatureFlags',
  systemBWAppsUrls: 'Sys/AppStoreUrls',
  adminBoardSettings: 'Admin/Settings',
  agendaColors: 'AgendaColors',
  agendaColorsDefaults: 'AgendaColors/Default',
  sysPartialSave: 'Sys/PartialSave',
  ExtUserLogin: 'ExternalUser/Login',
  ExternalUser: 'ExternalUser',
  MeetingDetails: 'MeetingDetails',
  aiDocSummary: 'AiDocSummary',
  upsertDeleteExternalUser: 'UpsertDelete/ExternalUser',
  externalUsers: 'ExternalUsers',
  AgendaItems: 'AgendaItems',
  IsValidUrlDetails: 'ExternalUser/IsValidUrlDetails',
  browserAccessInfo: 'Admin/Users/BrowserAccessInfo',
  questionTitle: 'QuestionTitle'
};
